import type { Resource } from '../../';
export const country_countries_BR: Resource = {"default":"Brazil"};
